import { gql } from "@apollo/client";

export const LIST_MANUFACTURERS = gql`
  query listManufacturers {
    listManufacturers {
       brand
       id
       isTreeMaker
    }
}
`;